import { Routes, Route } from "react-router-dom";

import CollectionListScreen from "screens/App/CRM/Collection/CollectionListScreen";
import CollectionInfoScreen from "screens/App/CRM/Collection/CollectionInfoScreen";
import CollectionDetailScreen from "screens/App/CRM/Collection/CollectionDetailScreen";
import CollectionEditScreen from "screens/App/CRM/Collection/CollectionEditScreen";
import CollectionCreateScreen from "screens/App/CRM/Collection/CollectionCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const CollectionRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<CollectionListScreen />} />
      <Route path="create" element={<CollectionCreateScreen />} />
      <Route path=":id/detail" element={<CollectionDetailScreen />} />
      <Route path=":id/edit" element={<CollectionEditScreen />} />
      <Route path="info" element={<CollectionInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default CollectionRouter;
